<div class="media profile-media" *ngIf="user">
  <!-- <img class="b-r-10" src="assets/images/dashboard/profile.jpg" alt=""> -->
  <div class="media-body"><span>{{userName}}</span>
    <p class="mb-0 font-roboto">{{jobTitle}} 
      <i class="middle fa fa-angle-down"></i></p>
  </div>
</div>
<ul class="profile-dropdown onhover-show-div">
  <li style="white-space: nowrap;" (click)="profile();"><app-feather-icons [icon]="'user'"></app-feather-icons><span style="white-space: nowrap;">{{'Profile' | translate}} </span></li>
  <!-- <li><a href="email"><app-feather-icons [icon]="'mail'"></app-feather-icons><span>Inbox</span></a></li> -->
  <!-- <li><a href="/to-do"><app-feather-icons [icon]="'file-text'"></app-feather-icons><span>Taskboard</span></a></li> -->
  <!-- <li><a href="/faq"><app-feather-icons [icon]="'settings'"></app-feather-icons><span>Settings</span></a></li> -->
  <li (click)="logoutFunc()"><app-feather-icons [icon]="'log-in'"></app-feather-icons><span>{{'Logout' | translate}}</span></li>
</ul>